import { render, staticRenderFns } from "./VideoSection.vue?vue&type=template&id=6a0b84a8&scoped=true"
import script from "./VideoSection.vue?vue&type=script&lang=js"
export * from "./VideoSection.vue?vue&type=script&lang=js"
import style0 from "./VideoSection.vue?vue&type=style&index=0&id=6a0b84a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0b84a8",
  null
  
)

export default component.exports